import Vue from 'vue';

const success = (response, context) => {
  if (response.data.roomCodes && response.data.roomCodes.length > 0) {
    context.rental.booking_room_id = response.data.roomCodes[0].code;
  }
  if (response.data.rateCodes && response.data.rateCodes.length > 0) {
    context.rental.booking_rate_id = response.data.rateCodes[0].code;
  }
  context.rateCodes = response.data.rateCodes;
  context.roomCodes = response.data.roomCodes;
  context.smallLoading = false;
};

const failed = (error, context) => {
  context.smallLoading = false;
  context.showToasterError(error);
};

export default (context, data) => {
  return Vue.$http.post('/get-rooms-and-rates-codes', data)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/getBookingComRoomsAndRatesCodes.js